import React from 'react';
import { PageHero } from '../components/PageHero';
import { SectionHeading } from '../components/SectionHeading';
import { ProductCard } from '../components/shop/ProductCard';
import { images } from '../data/images';
import { products } from '../data/products';
export function Shop() {
  const online = products.filter(p => !p.inHouse);
  const inHouse = products.filter(p => p.inHouse);
  const grid = 'grid gap-x-[clamp(16px,1.6vw,40px)] gap-y-[clamp(36px,3vw,70px)] sm:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 min-[2400px]:grid-cols-6';
  return <>
      <PageHero title="Shop" subtitle="Merch, deposits & gift certificates" image={images.giftCertificate} data-id="element-517" data-mp="3dzosxlnnslyx" />
      <section className="px-6 pb-[clamp(50px,5vw,120px)]" aria-label="Shop products" data-id="element-518" data-mp="3998fw2nr32d3">
        <div className={grid} data-id="element-519" data-mp="3975igxk9q6yc">
          {online.map(product => <ProductCard key={product.slug} product={product} data-id="element-520" data-mp="2lhji46s5tlor" />)}
        </div>
      </section>
      <section className="border-t border-ink-line py-[clamp(50px,5vw,120px)]" data-id="element-521" data-mp="2gk18ee6bj2fp">
        <div className="px-6" data-id="element-522" data-mp="3djicuc53jgy1">
          <SectionHeading eyebrow="At the shop" title="In-House Products" text="Available at the shop. Stop by Trip Ink Tattoo Company to pick them up." data-id="element-523" data-mp="3dih3qd7n54iy" />
          <div className={`mt-12 ${grid}`} data-id="element-524" data-mp="3nb62c7i3enwv">
            {inHouse.map(product => <ProductCard key={product.slug} product={product} data-id="element-525" data-mp="3rbyd556m50v9" />)}
          </div>
        </div>
      </section>
    </>;
}